import { defineStore } from 'pinia';
import { ref, computed } from 'vue';

export const useUserPermissionStore = defineStore('userPermission', () => {
  const permissionsArr = ref<number[]>([]);
  const hasPermission = computed(() => (permission: number) => permissionsArr.value.includes(permission));

  function updatePermission(permissions: number[]) {
    permissionsArr.value = [...new Set([...permissionsArr.value, ...permissions])];
  }

  return { hasPermission, updatePermission };
});
